import React from "react";
import Menubar from "../../Shared/Header/Menubar/Menubar"
const Blogs = () => {
  return (
    <>
    <Menubar></Menubar>
      <div className="row">
        <h1 className="text-center fw-bold my-5 py-5 ">Blogs Coming Soon!!</h1>
      </div>
    </>
  );
};

export default Blogs;
